@if (isPdfPreview) {
  <iframe class="pdf-preview-frame" [src]="documentSrc" width="100%" [style.height]="height"></iframe>
} @else if (isImagePreview) {
  <div class="image-preview-shell" [style.height]="height">
    <img class="image-preview" [src]="documentSrc" alt="Document preview">
  </div>
} @else {
  <div class="unsupported-preview">
    Preview is not supported for this file type.
  </div>
}
